import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main role="alert" style={{ maxWidth: 620, margin: '12vh auto', padding: 24 }}>
      <h1>Sidan kunde inte laddas</h1>
      <p>Kontrollera din anslutning och ladda om sidan. Din sparade varukorg finns kvar.</p>
      <button className="btn btn-success" onClick={() => window.location.reload()}>Ladda om sidan</button>
      <p style={{ marginTop: 16 }}><a href="/">Till startsidan</a></p>
    </main>;
  }
}
